<script setup lang="ts">import { computed } from 'vue';
import { clearError } from '@/runtime';
import { division } from '@/runtime/division';

const props = defineProps<{ error: { statusCode?: number; message?: string } }>();
const code = computed(() => {
  const status = Number(props.error.statusCode ?? 500);
  if (status === 404) return 404;
  if (status === 403) return 403;
  return 500;
});
const copy = {
  404: { label: 'Не удалось открыть страницу', title: 'Здесь пока ничего нет', text: 'Проверьте адрес или вернитесь на главную.' },
  403: { label: 'Доступ ограничен', title: 'Раздел вам недоступен', text: 'Похоже, у вашей роли нет сюда доступа. Если доступ нужен — попросите руководителя выдать право.' },
  500: { label: 'Что-то сломалось', title: 'Попробуем ещё раз', text: 'Страница могла обновиться или соединение прервалось. Обновите её или вернитесь на главную.' },
} as const;
// Прежний error.vue СНиМК: крупный номер, подпись по статусу и «На главную».
const legacy = computed(() => {
  if (division.value?.appearance !== 'snimk') return null;
  return {
    404: { title: 'Такой страницы нет', text: 'Проверьте адрес — возможно, страницу переименовали.' },
    403: { title: 'Раздел вам недоступен', text: props.error.message || 'Это место открыто не всем. Если доступ нужен — попросите председателя выдать право.' },
    500: { title: 'Что-то сломалось', text: 'Мы записали ошибку. Попробуйте обновить страницу.' },
  }[code.value]!;
});
function retry() { clearError(); }
function home() { clearError({ redirect: '/' }); }
</script>
<template>
  <main v-if="legacy" class="flex min-h-screen items-center justify-center px-4 text-center">
    <div>
      <p class="font-display text-[4rem] leading-none font-bold text-brand">{{ code }}</p>
      <h1 class="font-display mt-2 text-xl font-bold text-body">{{ legacy.title }}</h1>
      <p class="mt-2 text-sm text-muted">{{ legacy.text }}</p>
      <button type="button" class="press sn-primary mt-5" @click="home">На главную</button>
    </div>
  </main>
  <main v-else class="login-page legacy-ui" data-appearance="finfac"><section class="surface" style="max-width: 600px; margin: 0 auto; padding: 60px 28px"><span class="small-label">{{ copy[code].label }}</span><h1>{{ copy[code].title }}</h1><p style="margin: 24px 0">{{ copy[code].text }}</p><div class="event-actions"><button v-if="code === 500" class="primary-button press" @click="retry">Обновить страницу</button><button :class="code === 500 ? 'outline-button press' : 'primary-button press'" @click="home">На главную</button></div></section></main>
</template>
